import type { AppProps, AppContext } from 'next/app';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Layout, ILayoutProps } from '@/components/layout';
import Head from 'next/head';
import { IndexContext } from "@/stores";
import axios from 'axios';

import App from 'next/app';
import './global.scss';
import { IndexContextProvider } from '@/stores';

axios.defaults.withCredentials = true;


export interface IComponentProps {
  lang?: string;
}

const MyApp = (_data: AppProps & ILayoutProps & IComponentProps): JSX.Element => {
  const { Component, navbarData, pageProps, footerData, enNavbarData, enFooterData } = _data;
  // const getData = useCallback(async () => {
  //   const { data: _data } = await axios.get('/api/get_config')
  //   localStorage.setItem('head', JSON.stringify(_data?.data))
  // }, [])

  // useEffect(() => {
  //   getData()
  // }, [])

  useEffect(() => {
    const loadFont = async () => {
      //@ts-ignore
      await import('@/public/font/font.css');
    };
    loadFont();
  }, [])

  return (
    <div>
      <Head>
        <meta name="baidu-site-verification" content="codeva-z8bL0PSeuE" />
        <meta name="viewport" content="user-scalable=no" />
        <meta name="viewport" content="initial-scale=1,maximum-scale=1" />
        <meta name='thumbnail' content='https://www.cbcechina.com/image/logo.png?v=20250422' />
        {/* 默认的tdk */}
        <title>亚洲精酿啤酒会议暨展览会</title>
        <meta name="keywords" content="CBCE啤酒展,CBCE精酿啤酒展会,亚洲精酿啤酒展,2025上海精酿啤酒展,精酿啤酒展,cbcechina" />
        <meta name="description" content="CBCE 2025将于4月15-17日在上海新国际博览中心华丽启幕，聚焦消费升级时代下的行业热点，本届展会主题展区焕新升级，推出六大系列展区：设备原料展区、精酿啤酒展区、低度潮饮专区、蒸馏烈酒专区、精酿配餐专区和制罐标签印刷专区，集中差异化展示产业链各环节优质企业的产品亮点与优势。多维度、多方位拓展品牌与渠道和市场的接触面，为精酿行业注入源源不断的活力与热情。
亚洲精酿啤酒会议暨展览会（CBCE）是亚洲权威的精酿行业国际盛会，自2016年在中国上海成功举办以来，已经成为从酿酒原料、装备制造再到成品精酿的行业领先的专业展览会。CBCE聚集了从酿酒原料、装备制造再到终端消费全产业链上下游各环节相关产品，云集海内外知名品牌企业，打造亚太地区一站式精酿平台。展会现场将呈现10+场同期活动，内容包括技术峰会、布鲁塞尔啤酒挑战赛获奖酒款品鉴会、欧洲之星获奖酒款品鉴会、新书推介会、CBCE中国精酿之旅版图、CBCE“云逛展”与线上直播访谈、VIP晚宴暨“布鲁塞尔挑战赛”中国区颁奖典礼等。"/>
        <link rel="shortcut icon" type="image/x-icon" href="/image/logo.png?v=20250422" />
        <script
          defer
          dangerouslySetInnerHTML={{
            __html: `
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?d88812b706e7e120a8177951b2a61433";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();
    `,
          }}
        />
      </Head>
      <IndexContextProvider>
        <Layout
          navbarData={navbarData}
          footerData={footerData}
          enNavbarData={enFooterData}
          enFooterData={enFooterData}>
          <Component {...pageProps} />
        </Layout>
      </IndexContextProvider>
    </div>
  );
};

export default MyApp;
